import React, { PureComponent } from "react";
import axios from "axios";
import { server } from "../env";

class Announcement extends PureComponent {
  state = {
    announcement: "",
    isAnnouncement: false,
  };

  componentDidMount = () => {
    axios.get(server + "/v1/announcement/read").then((rsp) => {
      this.setState({
        announcement: rsp.data.payload[0],
        isAnnouncement: rsp.data.payload[0].status,
      });
    });
  };

  render() {
    const { announcement, isAnnouncement } = this.state;
    return isAnnouncement ? (
      <div className="alert alert-primary w-100 mt-0" style={{ borderRadius: "0" }}>
        {announcement.title}
      </div>
    ) : (
      ""
    );
  }
}

export default Announcement;
